export const statusColorMap = {
  "0": "#FFC107",
  "3": "#39b54a",
  "2": "#FF4842",
  "4": "#78909C",
  "1": "#1817A8"
};
